import type { CSSProperties } from 'react';

import { ADS_PLATFORM_LETTER } from './adsPlatform';
import type { AdsPlatform } from '@/types';

/**
 * 平台品牌方塊(R299;D3 廣告串接 `.acct-ic.g` / `.acct-ic.m`):淡底 + 粗體字母。
 *
 * 尺寸三檔對齊 D3:`md` 40(表格名稱欄 / 抽屜頭)、`sm` 26(媒體欄 / 分組標題)、
 * `lg` 46(授權面板 `.auth-ic`)。顏色走 theme token(`--brand-{platform}-*`,兩主題各一組)。
 * `Record<AdsPlatform, …>` 是編譯期閘 —— 加平台沒補色票 tsc 會紅。
 */
const TILE_COLORS: Record<AdsPlatform, { bg: string; fg: string }> = {
  google: { bg: 'var(--brand-google-bg)', fg: 'var(--brand-google-fg)' },
  meta: { bg: 'var(--brand-meta-bg)', fg: 'var(--brand-meta-fg)' },
};

const SIZE_PX = { sm: 26, md: 40, lg: 46 } as const;
const RADIUS_PX = { sm: 8, md: 11, lg: 14 } as const;
const FONT_PX = { sm: 11, md: 14, lg: 16 } as const;

export function AdsPlatformIcon({
  platform,
  size = 'md',
  title,
  style,
}: {
  platform: AdsPlatform;
  size?: keyof typeof SIZE_PX;
  /** 滑過去的全名(呼叫端給 i18n 字串);省略 = 純裝飾。 */
  title?: string;
  style?: CSSProperties;
}) {
  const c = TILE_COLORS[platform];
  const px = SIZE_PX[size];
  return (
    <span
      aria-hidden={title ? undefined : true}
      title={title}
      data-testid={`ads-platform-icon-${platform}`}
      style={{
        width: px,
        height: px,
        flex: `0 0 ${px}px`,
        borderRadius: RADIUS_PX[size],
        background: c.bg,
        color: c.fg,
        display: 'inline-grid',
        placeItems: 'center',
        fontSize: FONT_PX[size],
        fontWeight: 800,
        fontFamily: 'var(--font-mono)',
        lineHeight: 1,
        userSelect: 'none',
        ...style,
      }}
    >
      {ADS_PLATFORM_LETTER[platform]}
    </span>
  );
}
